/**
 * @generated SignedSource<<c221bf27608a846f7a657652c1374f0a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type OrganizationRole = "admin" | "member" | "owner" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type OrganizationMembersCardViewDashboardBlock_organizationMembershios_PaginationFragment$data = {
  readonly id: string;
  readonly organizationMemberships: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "OrganizationMembership";
        readonly id: string;
        readonly member: {
          readonly bio: string;
          readonly fullName: string;
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarWithDetailsFragment">;
        };
        readonly role: OrganizationRole;
      };
    }>;
    readonly totalCount: number;
  };
  readonly " $fragmentType": "OrganizationMembersCardViewDashboardBlock_organizationMembershios_PaginationFragment";
};
export type OrganizationMembersCardViewDashboardBlock_organizationMembershios_PaginationFragment$key = {
  readonly " $data"?: OrganizationMembersCardViewDashboardBlock_organizationMembershios_PaginationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrganizationMembersCardViewDashboardBlock_organizationMembershios_PaginationFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "organizationMemberships"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organizationRoles"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./OrganizationMembersCardViewDashboardBlock_organizationMembershios_PaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "OrganizationMembersCardViewDashboardBlock_organizationMembershios_PaginationFragment",
  "selections": [
    {
      "alias": "organizationMemberships",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "members_list"
        },
        {
          "kind": "Variable",
          "name": "roles",
          "variableName": "organizationRoles"
        }
      ],
      "concreteType": "OrganizationMembershipNodeConnection",
      "kind": "LinkedField",
      "name": "__MembersListDashboardBlock__organizationMemberships_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationMembershipNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrganizationMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "role",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "member",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bio",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fullName",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ProfileAvatarWithDetailsFragment"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfoObjectType",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "01a162284c98a9d6d2c04042f1c459f0";

export default node;
